import { Action } from '../../actions';
import { mergeObject } from '../../helpers';
import { transformNavigationUserOnPaytmMembershipPlan } from './paytm.transformers';

export function navigationUserOnPaytmMembershipPlanReducer(
  state = {},
  action: Action,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'navigationUserOnPaytmMembershipPlan') {
        const { result, ref } = action.payload;
        return mergeObject<'navigationUserOnPaytmMembershipPlan'>(
          state,
          transformNavigationUserOnPaytmMembershipPlan(result),
          ref,
        );
      }
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/datastore/navigation/paytm/paytm.reducer.ts